import { render, staticRenderFns } from "./ImovelCadastroDialog.vue?vue&type=template&id=0524de4f&scoped=true&"
import script from "./ImovelCadastroDialog.vue?vue&type=script&lang=js&"
export * from "./ImovelCadastroDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImovelCadastroDialog.vue?vue&type=style&index=0&id=0524de4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524de4f",
  null
  
)

export default component.exports